/* @flow */
import * as React from 'react';

const JunkRemovalSmall = props => (
  <svg
    width={28}
    height={26}
    viewBox="0 0 28 26"
    stroke="none"
    strokeWidth={1}
    fillRule="evenodd"
    {...props}>
    <defs>
      <path
        d="M20,8 L3,8 C2.447,8 2,8.447 2,9 L2,23 C2,23.552 2.448,24 3,24 L20,24 C20.552,24 21,23.552 21,23 L21,9 C21,8.447 20.553,8 20,8 Z"
        id="path-1"
      />
      <mask
        id="mask-2"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="19"
        height="16"
        fill="white">
        <use xlinkHref="#path-1" />
      </mask>
    </defs>
    <g id="assets" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Icons" transform="translate(-368.000000, -547.000000)">
        <g id="icons/junk-removal-small" transform="translate(368.000000, 547.000000)">
          <path
            d="M18.6947413,0.305493139 C18.2877298,-0.101831046 17.6273336,-0.101831046 17.2203221,0.305493139 L13,5.08648183 L8.77967793,0.305493139 C8.37266638,-0.101831046 7.71326778,-0.101831046 7.30525866,0.305493139 C6.89824711,0.71381812 6.89824711,1.37634542 7.30525866,1.7846704 L12.2019382,7.70356474 C12.4214052,7.92373998 12.7126977,8.01581326 13,7.99779892 C13.2873023,8.01581326 13.5785948,7.92373998 13.7980618,7.70356474 L18.6947413,1.7846704 C19.1017529,1.37634542 19.1017529,0.71381812 18.6947413,0.305493139 Z"
            id="Shape"
            fill="#FFFFFF"
          />
          <path
            d="M26.154,6.00100041 C26.152,6.00100041 1.855,6 1.855,6 C0.828,6.00300123 0,5.80632986 0,6.79673503 L0,10.9920422 L0,25.1442408 C0,26.1686599 0.831,26 1.855,26 L26.147,26 C27.172,26 28.002,26.1686599 28.002,25.1442408 L28.002,10.9930426 L28.002,6.79773544 C28.003,5.80632986 27.176,6.00300123 26.154,6.00100041 Z"
            id="Shape"
            fill="#FFFFFF"
            fillRule="nonzero"
          />
          <ellipse id="Oval" fill="#1C1F34" fillRule="nonzero" cx="25" cy="14" rx="1" ry="1" />
          <rect id="Rectangle-3" fill="#1C1F34" x="23" y="18" width="3" height="5" rx="1" />
          <ellipse id="Oval" fill="#1C1F34" fillRule="nonzero" cx="25" cy="10" rx="1" ry="1" />
          <use
            id="Shape"
            stroke="#1C1F34"
            mask="url(#mask-2)"
            strokeWidth="2"
            fill="#677BC5"
            fillRule="nonzero"
            xlinkHref="#path-1"
          />
          <g id="Group-13" transform="translate(11.000000, 9.000000)">
            <polyline
              id="Stroke-19"
              stroke="#1C1F34"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.432107907 0.251028609 2.63116055 2.78901068 0.304063357 3.96935549 1.34937034 4.72393126 0.594720394 6.00972919 3.09670272 6.88637334 4.05816184 4.62225997 7.37075207 2.34719562"
            />
            <polyline
              id="Stroke-20"
              stroke="#1C1F34"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="8.59065255 5.93411258 5.76794521 6.26792666 4.50642078 6.94069539 3 6.94069539 1.84438202 8.76923077 6.6144506 8.87265302 4.15112709 10.7979471 5.40571594 12"
            />
            <path
              d="M4.59171489,8.85065667 L5.83605837,6.59211319 L3,7.06752419 C3,7.06752419 2.27079545,8.07663944 2.33528764,8.42498485 C2.39977983,8.77333027 4.59171489,8.85065667 4.59171489,8.85065667 Z"
              id="Fill-21"
              fill="#1C1F34"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default JunkRemovalSmall;



// WEBPACK FOOTER //
// ./src/assets/images/icons/junk-removal-small.js